module.exports = __webpack_public_path__ + "static/media/top-banner.f9c90f02.png";